import { Moment } from 'moment';
import { DayOfWeek } from 'core/day-of-week';

type WorkingDaysConfiguration = { [day in DayOfWeek]: boolean };

export const AllWorkingDayConfig: WorkingDaysConfiguration = {
  [DayOfWeek.Monday]: true,
  [DayOfWeek.Tuesday]: true,
  [DayOfWeek.Wednesday]: true,
  [DayOfWeek.Thursday]: true,
  [DayOfWeek.Friday]: true,
  [DayOfWeek.Saturday]: true,
  [DayOfWeek.Sunday]: true,
};

const isNonWorkingDay = (
  date: Moment,
  workingDays: WorkingDaysConfiguration,
): boolean => !workingDays[date.locale('en').format('dddd')];

export const getDateAfterSomeNumberOfWorkingDays = (
  startDate: Moment,
  numberOfDays: number,
  workingDays: WorkingDaysConfiguration,
): Moment => {
  let daysLeft = numberOfDays;
  let currentDate = startDate.clone();

  while (daysLeft > 0) {
    currentDate = currentDate.add(1, 'day');
    if (!isNonWorkingDay(currentDate, workingDays)) {
      daysLeft -= 1;
    }
  }

  return currentDate;
};
